import React, { createContext, useContext, useEffect, useState } from 'react';

const CartContext = createContext(null);
const KEY = 'osho_cart';

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  });

  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(items)); }, [items]);

  const addItem = (product, qty = 1) => {
    setItems((prev) => {
      const found = prev.find((i) => i.product_id === product.id);
      if (found) return prev.map((i) => i.product_id === product.id ? { ...i, quantity: Math.min(99, i.quantity + qty) } : i);
      return [...prev, {
        product_id: product.id, slug: product.slug, title: product.title, price: product.price,
        image: product.image, product_type: product.product_type, quantity: qty,
      }];
    });
  };
  const removeItem = (id) => setItems((prev) => prev.filter((i) => i.product_id !== id));
  const updateQty = (id, qty) => setItems((prev) => prev.map((i) => i.product_id === id ? { ...i, quantity: Math.max(1, qty) } : i));
  const clear = () => setItems([]);

  const count = items.reduce((s, i) => s + i.quantity, 0);
  const subtotal = items.reduce((s, i) => s + i.price * i.quantity, 0);

  return (
    <CartContext.Provider value={{ items, addItem, removeItem, updateQty, clear, count, subtotal }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
